import { render, staticRenderFns } from "./clockCat.vue?vue&type=template&id=40069972&scoped=true&"
import script from "./clockCat.vue?vue&type=script&lang=js&"
export * from "./clockCat.vue?vue&type=script&lang=js&"
import style0 from "./clockCat.vue?vue&type=style&index=0&id=40069972&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40069972",
  null
  
)

export default component.exports